import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';

// Themed hover tooltip for the sidebar. It is drawn in a portal with fixed positioning, so the sidebar's own
// overflow clipping cannot cut it off, and it only appears when the link text is actually shortened with "…".
export const useNavTip = () => {
    const [tip, setTip] = useState(null);

    const onEnter = useCallback((event, label) => {
        const row = event.currentTarget;
        const text = row.querySelector('[data-nav-label]');
        if (text && text.scrollWidth <= text.clientWidth) return; // the whole name is visible already
        const box = row.getBoundingClientRect();
        setTip({ label, top: box.top + box.height / 2, left: box.right + 10 });
    }, []);
    const onLeave = useCallback(() => setTip(null), []);

    const node = tip && createPortal(
        <div role="tooltip" style={{
            position: 'fixed', top: tip.top, left: tip.left, transform: 'translateY(-50%)', zIndex: 4000, pointerEvents: 'none',
            padding: '7px 12px', borderRadius: '9px', background: 'var(--admin-primary)', color: '#fff',
            font: '600 12.5px/1.3 Inter, system-ui, sans-serif', whiteSpace: 'nowrap',
            boxShadow: '0 10px 24px rgba(0, 0, 0, .22)',
        }}>
            <span style={{
                position: 'absolute', top: '50%', left: '-4px', width: '8px', height: '8px',
                transform: 'translateY(-50%) rotate(45deg)', background: 'var(--admin-primary)', borderRadius: '2px',
            }} />
            {tip.label}
        </div>,
        document.body,
    );

    return { onEnter, onLeave, node };
};
